import type { DatePickerProps } from 'components/ui/form/DatePicker/index.js';
import { DatePicker } from 'components/ui/form/DatePicker/index.js';
import type { GenericFormField } from 'components/ui/form/GenericForm/index.js';
import { DateFormatEnum } from 'components/ui/utils/dateFormats.js';
import type { Dayjs } from 'dayjs';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

export interface FormDatePickerProps<T> {
  field: GenericFormField<DatePickerProps['componentProps']>;
  control: Control;
  transform?: {
    onChange: (date: Dayjs) => T;
    value: (date: T | undefined) => Dayjs | undefined;
  };
}

export const FormDatePicker = <T, >({ control, field, transform }: FormDatePickerProps<T>) => {
  return (
    <Controller
      key={`${field.name}`}
      name={field.name}
      control={control}
      render={({ field: { onChange, value } }) => {
        const valueToUse = (() => {
          if (value === undefined) {
            return null;
          }

          return transform ? transform.value(value) : value;
        })();

        return (
          <DatePicker
            disabled={field?.disabled}
            placeholder={field?.placeholder}
            onChange={date => onChange(transform ? transform.onChange(date) : date)}
            value={valueToUse}
            componentProps={field?.componentProps}
            format={
              field.componentProps?.views?.includes('year') ? DateFormatEnum.YYYY : DateFormatEnum.MDY
            }
          />
        );
      }}
    />
  );
};
